var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserDetail',{attrs:{"userId":_vm.user_id}}),_vm._v(" "),_c('UserTabs',{attrs:{"userId":_vm.user_id}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007ec25a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userDetail/userManagementDetail.vue
// module id = null
// module chunks = 